import React from 'react';
import { useNavigate } from 'react-router-dom';
import { EmptyState } from '../components/ui';

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div className="page-container">
      <EmptyState
        icon="alert"
        title="Seite nicht gefunden"
        description="Diese Adresse gibt es nicht (mehr). Über das Menü links oder die Suche (Strg+K) findest du alles wieder."
        action={{ label: 'Zur Startseite', to: '/' }}
        secondaryAction={{ label: 'Zurück', onClick: () => navigate(-1) }}
      />
    </div>
  );
};

export default NotFoundPage;
